import { Volunteering } from '../types';

export const volunteering: Volunteering[] = [
    {
        role: "App Development Specialist",
        org: "Action Lab for Development",
        duration: "Oct 2025 – Jan 2026",
        hours: "120+ hours",
        category: "Science and Technology",
        featured: true,
        description: "Architected and deployed MoralityCode — a cross-platform Flutter app from scratch, reducing development time by 60% and successfully publishing on both Google Play Store and App Store. Implemented CodeMagic CI/CD pipeline for automated iOS deployment and streamlined release management across both platforms.",
        appLink: "https://apps.apple.com/us/app/moralitycode/id6756179566",
        appLabel: "App Store",
        appLink2: "https://play.google.com/store/apps/details?id=com.action_lab.morality_code",
        appLabel2: "Google Play",
        certificate: "https://www.unv.org/"
    },
    {
        role: "Promoter & Digital Creator",
        org: "Ministry of Youth Affairs",
        duration: "Oct 2025 – Dec 2025",
        hours: "100+ hours",
        category: "Arts and Culture",
        featured: false,
        description: "Contributed 10 hours per week supporting the promotion of culture, creativity, and youth empowerment — specifically working on the Ngoma Awards and 2025 Regional Awards on X (Twitter) and Instagram platforms.",
        certificate: "https://www.unv.org/"
    },
    {
        role: "Online Volunteer",
        org: "United Nations",
        duration: "Aug 2025 – Nov 2025",
        hours: "~80 hours",
        category: "Human Rights",
        featured: false,
        description: "Promoted the 80th anniversary of the United Nations through various social media platforms to support the Sustainable Development Goals, contributing 5 hours per week.",
        certificate: "https://www.unv.org/"
    },
    {
        role: "Quality Assurance Engineer",
        org: "United Nations Development Programme (UNDP)",
        duration: "Jul 2025",
        hours: "~20 hours",
        category: "Education",
        featured: false,
        description: "Contributed as a QA engineer to ensure functionality, UX, security, and enhancements for the Knowledge4All portal — a global UN learning platform.",
        platformLink: "https://www.knowledge4all.com/",
        platformLabel: "Knowledge4All",
        certificate: "https://www.unv.org/"
    },
    {
        role: "Arabic Translator",
        org: "United Nations Volunteers",
        duration: "Jan 2025",
        hours: "5 hours",
        category: "Human Rights",
        featured: false,
        description: "Contributed as an Online Volunteer with UNV to the Sustainable Development Goals by completing translation tasks at 5 hours per week.",
        certificate: "https://www.unv.org/"
    },
    {
        role: "Global Conversations Volunteer",
        org: "Acquaint",
        duration: "Jan 2025 – Present",
        hours: "10+ hours",
        category: "Arts and Culture",
        featured: false,
        description: "Connecting with people worldwide to promote peace, overcome hate, and strengthen global communication through guided 1-on-1 cross-cultural conversations.",
        platformLink: "https://www.acquaint.org/",
        platformLabel: "Acquaint",
        certificate: "https://www.acquaint.org/shared_certificates/6eda4711-29d1-4b08-afcf-ae1ec0367494"
    },
    {
        role: "WordPress Developer",
        org: "SORUDEO",
        duration: "Jan 2025 – Mar 2025",
        hours: "~60 hours",
        category: "Community",
        featured: false,
        description: "Developed and maintained WordPress-based web presence for the Solidarity for Rural Development Organisation, supporting their digital outreach and community development mission.",
    }
];
